import React from 'react'
import { Link } from 'react-router-dom'
import RightHandSide from "../Common/Services/RightHandSide"
import Transition from '../Transition'

const Blog = () => {
  return (
    <>
    <div className="blog-area pt-100 pb-70">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <div className="row">
                        {data.map((d, i) => (
                            <div key={i} className="col-lg-6 col-md-6 col-sm-6">
                                <div className="blog-card">
                                    <Link to={d.blogLink}><img src={d.BlogImg} className='rounded' alt="image1" /></Link>
                                    <Link to={d.careLink} className="care">{d.care}</Link>
                                    <h4>
                                        <Link to={d.blogLink}>{d.BlogHeading}</Link>
                                    </h4>
                                    <ul>
                                        <li className='first'>By <Link to="/Doctor">Admin</Link></li>
                                        <li className='second'>{d.date}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                        
                        
                    </div>
                    
                </div>
                <div className="col-lg-4">
                    <RightHandSide />
                </div>
            </div>
        </div>
    </div>
    
    
    </>
  )
}

export default Transition(Blog) 

const data = [
    {
        BlogImg: require("../../Assets/images/blog/headDesign/1.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/1/BlogDetails",
        BlogHeading: "How to Prepare for Your First IVF Cycle: A Step-by-Step Guide",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/2.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/2/BlogDetails",
        BlogHeading: "The Role of Genetics in IVF: What You Should Know",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/3.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/3/BlogDetails",
        BlogHeading: "IVF and Age: When is the Best Time to Start?",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/4.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/4/BlogDetails",
        BlogHeading: "The Latest Innovations in IVF Technology for 2024",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/5.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/5/BlogDetails",
        BlogHeading: "Importance of Mental Health Support During IVF Treatments",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/6.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/6/BlogDetails",
        BlogHeading: "Egg Freezing vs. IVF: Which is the Better Option for You? ",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/7.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/7/BlogDetails",
        BlogHeading: "Unexpected Challenges in IVF: How to Navigate Secondary Infertility",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/8.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/8/BlogDetails",
        BlogHeading: "Natural Ways to Boost Fertility Before Considering IVF",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/9.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/9/BlogDetails",
        BlogHeading: "IVF Success Rates & Statistics: Understanding Your Chances ",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/10.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/10/BlogDetails",
        BlogHeading: "PCOS and Fertility Explained: Understanding the Connection",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/11.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/11/BlogDetails",
        BlogHeading: "What is a Frozen Embryo Transfer (FET)?",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/12.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/12/BlogDetails",
        BlogHeading: "Fresh vs Frozen Embryo Transfer: Which is Better?",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/13.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/13/BlogDetails",
        BlogHeading: "Understanding IVF Fertility: A Journey of Hope and Science",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/14.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/14/BlogDetails",
        BlogHeading: "IVF and Relationships: Supporting Each Other Through the Journey",
        date: ""
    },
    {
        BlogImg: require("../../Assets/images/blog/headDesign/15.png"),
        careLink: "/Doctor",
        care: "Hospital",
        blogLink: "/15/BlogDetails",
        BlogHeading: "How Sleep and Mental Well-being Impact IVF Success",
        date: ""
    },
    

]
    

